import React, { useState, useEffect, useMemo } from 'react'
import { SelectFolder } from '../SelectFolder'

const MoveModal = ({ isOpen, onClose, folders = [], onMove, loading = false, currentFolderId = null, movingDocument = false }) => {
	const [selectedFolder, setSelectedFolder] = useState(null)
	const [error, setError] = useState('')

	const currentFolder = useMemo(() => folders.find(f => f.id === currentFolderId), [folders, currentFolderId])

	const getRootFolder = folder => {
		let current = folder
		while (current && current.parentId !== null) {
			current = folders.find(f => f.id === current.parentId)
		}
		return current
	}

	const treeType = useMemo(() => {
		if (!currentFolder) return undefined
		const root = getRootFolder(currentFolder)
		if (root?.private === true) return 'particular'
		if (root?.private === false) return 'common'
		return undefined
	}, [currentFolder, folders])

	const filteredFolders = useMemo(() => {
		if (!treeType) return []
		return folders.filter(folder => {
			const root = getRootFolder(folder)
			if (treeType === 'particular') return root?.private === true
			if (treeType === 'common') return root?.private === false
			return false
		})
	}, [folders, treeType])

	useEffect(() => {
		if (!isOpen) {
			setSelectedFolder(null)
			setError('')
		}
	}, [isOpen])

	const handleMove = async () => {
		if (!selectedFolder) {
			setError('Selecione uma pasta de destino')
			return
		}
		setError('')
		onMove(selectedFolder)
		onClose()
	}

	if (!isOpen) return null

	return (
		<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-z-50 tw-flex tw-items-center tw-justify-center'>
			<div className='tw-bg-white tw-rounded-xl tw-shadow-lg tw-p-6 tw-w-[634px]'>
				<div className='tw-text-lg tw-font-medium tw-mb-2'>
					{movingDocument ? (
						<>Mover documento</>
					) : (
						<>
							Mover la carpeta: <b>{currentFolder.name}</b>
						</>
					)}
				</div>
				<div className='tw-mb-4'>
					<SelectFolder folders={filteredFolders} onSelect={setSelectedFolder} selectedFolder={selectedFolder} legend={false} treeType={treeType} />
				</div>
				{error && <div className='tw-text-red-500 tw-mb-2'>{error}</div>}
				<div className='tw-flex tw-justify-end tw-gap-3'>
					<div
						onClick={onClose}
						className='border tw-px-4 tw-py-2 tw-text-gray-700 hover:tw-bg-gray-50 tw-cursor-pointer tw-rounded-lg'
						disabled={loading}
					>
						Cancelar
					</div>
					<div
						onClick={handleMove}
						className={`tw-bg-purple-500 tw-text-white tw-px-4 tw-py-2 hover:tw-bg-purple-700 tw-cursor-pointer tw-rounded-lg ${
							!selectedFolder || loading ? 'tw-opacity-50 tw-cursor-not-allowed' : ''
						}`}
						disabled={!selectedFolder || loading}
						style={{ pointerEvents: !selectedFolder || loading ? 'none' : 'auto' }}
					>
						{loading ? 'Moviendo...' : 'Mover'}
					</div>
				</div>
			</div>
		</div>
	)
}

export default MoveModal
